import { render, staticRenderFns } from "./ManejarDescansado.vue?vue&type=template&id=4d7dd38a&scoped=true&"
import script from "./ManejarDescansado.vue?vue&type=script&lang=js&"
export * from "./ManejarDescansado.vue?vue&type=script&lang=js&"
import style0 from "./ManejarDescansado.vue?vue&type=style&index=0&id=4d7dd38a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7dd38a",
  null
  
)

export default component.exports